import React, { useState } from "react";
import SectionTitle from "../../../components/section-title";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";
import { isMobile } from "react-device-detect";

const ServicesContainer = () => {
    const [activeTab, setActiveTab] = useState("1");

    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };
    return (
        <div className="section section-padding mt-n1 mb-n1">
            <div className="container">
                <SectionTitle classOption="section-title-2" title="Services" />

                <div className="faq-wrapper">
                    <div className="row">
                        <div className="col-lg-3">
                            <div className="faq-menu">
                                <Nav tabs className="nav flex-column">
                                    <NavItem>
                                        <NavLink
                                            className={classnames({
                                                active: activeTab === "1",
                                            })}
                                            onClick={() => {
                                                toggle("1");
                                            }}
                                        >
                                            Nutrition
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({
                                                active: activeTab === "2",
                                            })}
                                            onClick={() => {
                                                toggle("2");
                                            }}
                                        >
                                            Engram
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({
                                                active: activeTab === "3",
                                            })}
                                            onClick={() => {
                                                toggle("3");
                                            }}
                                        >
                                            Life and relationship coaching
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({
                                                active: activeTab === "4",
                                            })}
                                            onClick={() => {
                                                toggle("4");
                                            }}
                                        >
                                            Career coaching
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({
                                                active: activeTab === "5",
                                            })}
                                            onClick={() => {
                                                toggle("5");
                                            }}
                                        >
                                            Wisdom and intuition
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({
                                                active: activeTab === "6",
                                            })}
                                            onClick={() => {
                                                toggle("6");
                                            }}
                                        >
                                            Creative activities
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                            </div>
                        </div>
                        <div className="col-lg-9">
                            <TabContent
                                activeTab={activeTab}
                                style={{
                                    textAlign: isMobile ? "center" : "start",
                                }}
                            >
                                <TabPane tabId="1">
                                    <p>
                                        Soul Harmony House offers you
                                        personalized meal plans and diet
                                        counselling to help you achieve your
                                        physical and emotional balance. Our
                                        nutritionists understand that food is
                                        not only essential for your physical
                                        health, but also for your mental and
                                        emotional well-being as they work
                                        closely with you to develop meal plans
                                        that are tailored to your needs and
                                        preferences.
                                    </p>
                                </TabPane>
                                <TabPane tabId="2">
                                    <p>
                                        The Engram department offers a range of
                                        therapies and techniques to help
                                        individuals overcome limiting beliefs,
                                        negative thought patterns, and emotional
                                        traumas. This department recognizes that
                                        past experiences can have a profound
                                        impact on our present and future.
                                        Therefore, it offers a range of
                                        therapies, including
                                        cognitive-behavioral therapy,
                                        hypnotherapy, and neuro-linguistic
                                        programming, to help individuals
                                        overcome negative conditioning and
                                        achieve their full potential.
                                    </p>
                                </TabPane>
                                <TabPane tabId="3">
                                    <p>
                                        The Life and Relationship Coaching
                                        department provides guidance and support
                                        to help individuals navigate life&apos;s
                                        challenges and build healthy
                                        relationships. This department
                                        recognizes that our relationships with
                                        ourselves and others are essential for
                                        our overall happiness and well-being.
                                        Therefore, it offers coaching sessions
                                        to help individuals develop
                                        self-awareness, improve communication
                                        skills, and build stronger, more
                                        fulfilling relationships.
                                    </p>
                                </TabPane>
                                <TabPane tabId="4">
                                    <p>
                                        The Career Coaching department offers
                                        career counseling, job search
                                        assistance, and skill development to
                                        help individuals achieve their
                                        professional goals. This department
                                        understands that our professional lives
                                        are an important part of our overall
                                        well-being. Therefore, it offers support
                                        and guidance to help individuals
                                        identify their strengths, explore career
                                        options, and develop the skills they
                                        need to succeed.
                                    </p>
                                </TabPane>
                                <TabPane tabId="5">
                                    <p>
                                        The Wisdom and Intuition department
                                        offers spiritual guidance and practices
                                        to help individuals connect with their
                                        inner wisdom and intuition. This
                                        department recognizes that spirituality
                                        can play a vital role in our overall
                                        well-being. Therefore, it offers a range
                                        of practices, including meditation,
                                        yoga, and mindfulness training, to help
                                        individuals cultivate a deeper
                                        connection with themselves and the world
                                        around them.
                                    </p>
                                </TabPane>
                                <TabPane tabId="6">
                                    <p>
                                        Soul Harmony House offers a range of
                                        creative activities such as music,
                                        poetry, and art, to help individuals
                                        connect with their inner selves and
                                        express themselves in new ways. This
                                        department recognizes the importance of
                                        creativity in our overall well-being.
                                        Therefore, it offers opportunities for
                                        individuals to explore their creativity,
                                        connect with others, and have fun.
                                    </p>
                                </TabPane>
                            </TabContent>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ServicesContainer;
